/*
 * View for default category Description
 */

define(["marionette", "./template/categoryDescriptionTemplate.html"], function (
  Marionette,
  CategoryDescriptionTemplate,
) {
  var CategoryDescriptionView = {};

  CategoryDescriptionView.categoryDescriptionView = Marionette.ItemView.extend({
    template: CategoryDescriptionTemplate,
    textboxes: {
      "#categoryDescription": {
        enableSelector: "#categoryDescription",
        modelAttribute: "description",
        placeholder: "admin.categories.category.description",
        textArea: false,
      },
    },
  });

  return CategoryDescriptionView;
});
